/**
 * Created by jiachenpan on 16/11/18.
 * //const valid_map = ['admin', 'editor']
  //return valid_map.indexOf(str.trim()) >= 0
 */

export function isvalidUsername(str) {
  return true
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function btcguid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}



// WEBPACK FOOTER //
// ./src/utils/validate.js